import React, { useContext } from "react";


export const AdsContext = React.createContext<any>(null);

export const useAdsContext = (): any => {
    const context = useContext(AdsContext);
    return context;
};